<div class="filters">
  <form [formGroup]="formFilterFast" (ngSubmit)="filterSubmitFast()">
    <formly-form [form]="formFilterFast" [fields]="fieldsFeaturesFast" [options]="optionsFast"
                 [model]="modelFeaturesFast" (modelChange)="filterSubmitFast()"></formly-form>
  </form>
  <!--  <app-quick-filters-->
  <!--  >-->
  <!--  </app-quick-filters>-->
  <app-selected-filters [fieldsFeatures]="fieldsFeatures" [fieldsFeaturesFast]="fieldsFeaturesFast"/>
</div>
